<template>
    <div class="tyn-root">
        <Header></Header>

        <div class="tyn-content tyn-contact  has-aside-base">
            <HistoricoAnalisadores :reload="reload" :seleciona="seleciona" :novo="novo" :id="idProcessoResearch"></HistoricoAnalisadores>

            <div class="tyn-main tyn-content-inner" id="tynMain">
                <ul class="tyn-list-inline d-md-none translate-middle-x position-absolute start-50 z-1">
                    <li>
                        <button class="btn btn-icon btn-pill btn-white js-toggle-main" @click="fechar">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-lg" viewBox="0 0 16 16">
                                <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z" />
                            </svg><!-- x-lg -->
                        </button>
                    </li>
                </ul>
                <div class="tyn-chat-body m-4 rounded-3" data-simplebar>
                    <div class="container px-0">
                        <template v-if="idProcessoResearch == 0">
                            <div class="tyn-qa tyn-qa-bubbly">
                                <template v-if="flRealizaProcessoResearch">
                                    <template v-if="!(utilizacoes && utilizacoes.permiteRealizarResearch) && flVerificouUtilizacoes">
                                        <!-- nao pode realizar novo -->
                                        <div class="tyn-qa-item">
                                            <div class="tyn-qa-avatar">
                                                <div class="tyn-qa-avatar-wrap">
                                                    <div class="tyn-media tyn-size-md" style="background: transparent">
                                                        <img src="assets/images/sollai/avatar.png" alt="">
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="tyn-qa-message tyn-text-block bg-response">
                                                <p>
                                                    Desculpe, parece que você atingiu seu limite de Analisadores Processo do contrato.
                                                    Entre em contato com um dos nossos consultores.
                                                </p>
                                            </div>
                                        </div>
                                    </template>
                                    <!-- ETAPA 0  -->
                                    <template>
                                        <div class="tyn-qa-item">
                                            <div class="tyn-qa-avatar">
                                                <div class="tyn-qa-avatar-wrap">
                                                    <div class="tyn-media tyn-size-md" style="background: transparent">
                                                        <img src="assets/images/sollai/avatar.png" alt="">
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="tyn-qa-message tyn-text-block bg-response">
                                                <p>
                                                    <span class="fw-bold">O que deseja fazer hoje?</span> Selecione uma função na qual eu possa atuar para você.
                                                </p>
                                                <div class="d-flex align-items-center mb-1 ps-3" v-for="(item,index) in lstTipoResearch" :key="index">
                                                    <template v-if="item.tipoResearch">
                                                        <input type="radio" :id="'tipoResearch'+index" :name="'tipoResearch'+index" :value="item.tipoResearch.idTipoResearch" v-model="idTipoResearch" />
                                                        <!--<label for="tipoResearch">Resumo de documentos e apontamento de informações importantes (PDF ou arquivos em Word)</label>-->
                                                        <label class="ps-2" :for="'tipoResearch'+index" :data-bs-toggle="(item.tipoResearch.dsTipoResearch != null?'popoverModelo':'')" data-bs-placement="top" title="Detalhes" :data-bs-content="getDataBs(item.tipoResearch)">{{item.tipoResearch.dsNome}}</label>
                                                    </template>

                                                </div>
                                            </div>
                                        </div>
                                        <div class="row justify-content-end" v-if="etapa == 0">
                                            <div class="col text-end">
                                                <button type="button" class="btn btn-outline-primary" @click="proximo(0)" v-if="utilizacoes && utilizacoes.permiteRealizarResearch">Próximo</button>
                                            </div>
                                        </div>
                                    </template>

                                    <!-- ARQUIVOS -->
                                    <!-- ETAPA 1  -->
                                    <template v-if="etapa > 0">
                                        <div class="tyn-qa-item" ref="etapa1">
                                            <div class="tyn-qa-avatar">
                                                <div class="tyn-qa-avatar-wrap">
                                                    <div class="tyn-media tyn-size-md" style="background: transparent">
                                                        <img src="assets/images/sollai/avatar.png" alt="">
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="tyn-qa-message tyn-text-block bg-response">
                                                <p class="mb--20">Qual documento você deseja que eu trabalhe para você hoje?</p>
                                                <AvisoUploadDocumentos></AvisoUploadDocumentos>
                                                <template v-if="tipoResearch.lstTipoResearchBotao && tipoResearch.lstTipoResearchBotao.length > 0">
                                                    <p>Selecione um arquivo em <span id="negrito">word</span> ou <span id="negrito">pdf</span>.</p>

                                                    <div class="row">
                                                        <div class="col-6" :key="index" v-for="(item,index) in tipoResearch.lstTipoResearchBotao">
                                                            <ImputUploadS3 :reset="resetUpload" :labelText="item.dsNome" @onSave="setUploadFile" @onDelete="deleteUploadFile" :destino="'ProcessoResearch'" :multiple="true" :id="'input_file_research'+index" :maxFiles="2" :whoFiles="'.pdf,.doc,.docx'"></ImputUploadS3>
                                                        </div>
                                                    </div>
                                                </template>
                                                <template v-else>
                                                    <p>Selecione um arquivo em <span id="negrito">word</span> ou <span id="negrito">pdf</span>.</p>

                                                    <ImputUploadS3 :reset="resetUpload" :labelText="'Selecionar Arquivos'" @onSave="setUploadFile" @onDelete="deleteUploadFile" :destino="'ProcessoResearch'" :multiple="true" :id="'input_file_research'" :maxFiles="2"></ImputUploadS3>
                                                </template>

                                            </div>
                                        </div>
                                        <div class="row justify-content-end" v-if="etapa == 1">
                                            <div class="col text-end">
                                                <button type="button" class="btn btn-outline-primary" @click="proximo(1)" v-if="utilizacoes && utilizacoes.permiteRealizarResearch">Próximo</button>
                                            </div>
                                        </div>
                                    </template>

                                    <!-- ETAPA 2 -->
                                    <template v-if="etapa > 1">
                                        <div class="tyn-qa-item" ref="etapa2">
                                            <div class="tyn-qa-avatar">
                                                <div class="tyn-qa-avatar-wrap">
                                                    <div class="tyn-media tyn-size-md" style="background: transparent">
                                                        <img src="assets/images/sollai/avatar.png" alt="">
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="tyn-qa-message tyn-text-block bg-response">
                                                <template v-if="flRequerPromptUsuario">
                                                    <p class="mb-2">
                                                        Para que a resposta de <b v-if="tipoResearch && tipoResearch.tipoResearch">{{tipoResearch.tipoResearch.dsNome}}</b> seja mais precisa e alinhada ao contexto do seu edital, preencha abaixo com todas as informações que julgar relevantes. Descreva aqui o que você já sabe sobre o caso ou deseja destacar na resposta. Isso nos ajudará a gerar uma resposta personalizada, técnica e embasada para sua realidade . (Ex: justificativas técnicas, fundamentos legais, histórico do processo, decisões anteriores etc.)
                                                    </p>
                                                </template>
                                                <template v-else>
                                                    <p class="mb-2">Deseja fornecer mais algum detalhe? (não obrigatório)</p>
                                                </template>

                                                <div class="form-group">
                                                    <textarea class="form-control" id="pergunta" placeholder="Descreva os detalhes que achar relevantes" maxlength="5000" v-model="dsPrompt"></textarea>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row justify-content-end" v-if="etapa == 2">
                                            <div class="col text-end">
                                                <button type="button" class="btn btn-outline-primary" @click="proximo(2)" v-if="utilizacoes && utilizacoes.permiteRealizarResearch">Próximo</button>
                                            </div>
                                        </div>
                                    </template>

                                    <!-- NORMATIVA -->
                                    <template v-if="etapa > 2 && tipoResearch && tipoResearch.tipoResearch && tipoResearch.tipoResearch.flNorma && lstNormas.length > 0">
                                        <div class="tyn-qa-item" ref="etapa3">
                                            <div class="tyn-qa-avatar">
                                                <div class="tyn-qa-avatar-wrap">
                                                    <div class="tyn-media tyn-size-md" style="background: transparent">
                                                        <img src="assets/images/sollai/avatar.png" alt="">
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="tyn-qa-message tyn-text-block bg-response">
                                                <p class="fw-bold mb-2">Deseja utilizar alguma normativa:</p>
                                                <div class="d-flex align-items-center mb-1 ps-3" v-for="(item,index) in lstNormas" v-bind:key="index">
                                                    <input type="checkbox" :id="'normaResearch'+ index" :value="item.idNorma" v-model="lstIdNorma" :disabled="disabled" />
                                                    <label class="ps-2" :for="'normaResearch'+index">
                                                        {{item.dsNome}}
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row justify-content-end" v-if="etapa == 3">
                                            <div class="col text-end">
                                                <button type="button" class="btn btn-outline-primary" @click="proximo(3)" v-if="utilizacoes && utilizacoes.permiteRealizarResearch">Enviar</button>
                                            </div>
                                        </div>
                                    </template>
                                </template>
                                <template v-else-if="flVerificouRealizar">
                                    <div class="tyn-qa-item">
                                        <div class="tyn-qa-avatar">
                                            <div class="tyn-qa-avatar-wrap">
                                                <div class="tyn-media tyn-size-md" style="background: transparent">
                                                    <img src="assets/images/sollai/avatar.png" alt="">
                                                </div>
                                            </div>
                                        </div>
                                        <div class="tyn-qa-message tyn-text-block bg-response">
                                            <p>
                                                Aguarde a conclusão do analisador atual antes de realizar um novo.
                                            </p>
                                        </div>
                                    </div>
                                </template>
                            </div>
                        </template>
                        <template v-else>
                            <!-- RESULTADO -->
                            <div class="tyn-qa tyn-qa-bubbly">
                                <div class="tyn-qa-item" v-if="processoResearch">
                                    <div class="tyn-qa-avatar">
                                        <div class="tyn-qa-avatar-wrap">
                                            <div class="tyn-media tyn-size-md" style="background: transparent">
                                                <template v-if="user.usuarioApi">
                                                    <img v-if="user.usuarioApi.urlImgFoto" :src="user.usuarioApi.urlImgFoto" alt="" />
                                                    <img v-else src="assets/images/avatar/3.jpg" alt="">
                                                </template>
                                                <template v-else>
                                                    <img src="assets/images/avatar/3.jpg" alt="">
                                                </template>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="tyn-qa-message tyn-text-block bg-response">
                                        <p class="mb--0" v-if="processoResearch.dsNome">
                                            <strong>{{processoResearch.dsNome}}</strong>
                                        </p>
                                        <template v-if="processoResearch.usuario">
                                            <p class="mb--0" v-if="user.usuario.dsLogin != processoResearch.usuario.dsLogin">
                                                <strong>Usuário: </strong>{{processoResearch.usuario.nmUsuario}}
                                            </p>
                                        </template>
                                        <p class="mb--0" v-if="processoResearch.nmTipoResearch">
                                            <strong>Tipo: </strong> {{processoResearch.nmTipoResearch}}
                                        </p>
                                        <p class="mb--0" v-if="processoResearch.lstFonteDados">
                                            <strong>Fonte de dados: </strong>
                                            <a class="c-pointer item-fonte ms-2" href="javascript:void(0)" @click="downloadDocumento(item)" :key="index" v-for="(item,index) in processoResearch.lstFonteDados">{{getNomeArquivo(item.urlArquivo)}}</a>
                                        </p>
                                        <p class="mb--0">
                                            <strong>Data da solicitação: </strong>{{processoResearch.dtInclusao}}
                                        </p>
                                        <p class="mb--0" v-if="processoResearch.dsPrompt">
                                            <strong>Instrução: </strong>{{processoResearch.dsPrompt}}
                                        </p>
                                        <p class="mb--0" v-if="lstNormasSelecionadas && lstNormasSelecionadas.length > 0">
                                            <strong>Normativas: </strong>
                                            <span v-for="(item, index) in lstNormasSelecionadas" :key="item.idNorma || index">
                                                <a href="javascript:void(0)" @click="downloadNormativa(item.urlArquivo, item.dsNome)">
                                                    {{item.dsNome}}
                                                </a><span v-if="index < lstNormasSelecionadas.length - 1">, </span>
                                            </span>
                                        </p>
                                    </div>
                                </div>
                                <div class="tyn-qa-item">
                                    <div class="tyn-qa-avatar">
                                        <div class="tyn-qa-avatar-wrap">
                                            <div class="tyn-media tyn-size-md" style="background: transparent">
                                                <img src="assets/images/sollai/avatar.png" alt="">
                                            </div>
                                        </div>
                                    </div>
                                    <div class="tyn-qa-message tyn-text-block bg-response">
                                        <template v-if="statusProcessoResearch == 'Processando' || statusProcessoResearch == 'Iniciada'">
                                            <p class="fw-bold mb-2">
                                                {{mensagemProcessando}}
                                            </p>
                                            <p class="mb-2">
                                                Por favor, aguarde um momento enquanto eu processo sua solicitação. Obrigado pela sua paciência e compreensão.
                                            </p>
                                            <div class="progress px-0 d-none">
                                                <div class="progress-bar progress-bar-striped progress-bar-animated bg-blue-2" role="progressbar" aria-valuenow="timer" aria-valuemin="0" aria-valuemax="100" :style="{width: '20%'}"></div>
                                            </div>

                                        </template>
                                        <template v-if="statusProcessoResearch == 'Cancelada'">
                                            <span class="text-danger fs-1">
                                                <i class="fas fa-exclamation-triangle"></i>
                                            </span>
                                            <p class="fw-bold mb-2">
                                                Erro ao processar a solicitação
                                            </p>
                                            <p class="mb-2">
                                                Ocorreu um erro ao processar sua solicitação. Entre em contato com o suporte para mais detalhes.
                                            </p>
                                        </template>
                                        <template v-if="statusProcessoResearch == 'Finalizada'">
                                            <template vif="artefato">
                                                <p class="mb--20">Seu documento esta pronto!</p>
                                                <p>Faça o download do arquivo.</p>

                                                <div class="row justify-content-end" v-if="processoResearch.resposta">
                                                    <div class="col text-end">
                                                        <button class="btn btn-outline-primary" @click="downloadDocumento(processoResearch.resposta)" v-if="processoResearch.resposta && processoResearch.resposta.fileId">
                                                            <span class="ms-0">Fazer Download</span>
                                                        </button>
                                                    </div>
                                                </div>
                                            </template>
                                        </template>
                                    </div>
                                </div>
                            </div>
                            <div class="d-flex justify-content-center mt-3">
                                <button class="btn btn-outline-primary" @click="novo">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-plus-lg" viewBox="0 0 16 16">
                                        <path fill-rule="evenodd" d="M8 2a.5.5 0 0 1 .5.5v5h5a.5.5 0 0 1 0 1h-5v5a.5.5 0 0 1-1 0v-5h-5a.5.5 0 0 1 0-1h5v-5A.5.5 0 0 1 8 2" />
                                    </svg> Criar novo analisador
                                </button>
                            </div>
                        </template>
                    </div>
                </div>
            </div>
        </div>

        <!-- MODAIS HEADER -->
        <Modais></Modais>

        <ModalDetalhes :dados="modalDetalhes" :showModal="showModalDetalhes"></ModalDetalhes>
    </div>
</template>
<script>
    import Header from '@/components/Header'
    import HistoricoAnalisadores from '@/components/HistoricoAnalisadores'
    import Modais from '@/components/Modais'
    import ModalDetalhes from '@/components/ModalDetalhes'
    import ImputUploadS3 from '@/components/Input_Upload_s3'
    import AvisoUploadDocumentos from '@/components/AvisoUploadDocumentos'

    import { urlApi, avisoErro, avisoToast } from '@/config/global'
    import axios from 'axios'
    import moment from 'moment'

    export default {
        name: 'AnalisadoresProcesso',
        components: { Header, HistoricoAnalisadores, ModalDetalhes, ImputUploadS3, AvisoUploadDocumentos, Modais },
        computed: {
            user() {
                return this.$store.state.user
            },
            hubConection() {
                return this.$store.state.hubConection
            },
            lstNormas() {
                return this.$store.state.lstNormas
            },
        },
        data: function () {
            return {
                flInputText: false,
                reload: false,

                idProcessoResearch: 0,
                lstTipoResearch: [],
                idTipoResearch: 0,
                lstIdNorma: [],
                dsPrompt: null,

                arquivo: null,
                etapa: 0,
                msgErro: null,
                flReprocessar: false,
                statusProcessoResearch: null,
                processoResearch: null,
                reloadHistorico: false,
                disabled: false,
                tipoResearch: null,

                dropzoneOptions: {
                    url: urlApi + '/Documento/EnviarDocumento',
                    maxFilesize: 0.5,
                    thumbnailWidth: 200,
                    addRemoveLinks: true,
                    autoProcessQueue: false,
                    headers: { "My-Awesome-Header": "header value" }
                },

                flRealizaProcessoResearch: false,
                utilizacoes: null,
                flVerificouUtilizacoes: false,
                mensagemProcessando: "Processando solicitação...",
                flVerificouRealizar: false,

                modalDetalhes: {
                    cdConteudo: null,
                    idItemPesquisa: null,
                    dsReferencia: null,
                },

                showModalDetalhes: false,
                files: null,

                lstNormasSelecionadas: [],
                resetUpload: false,

                flRequerPromptUsuario: false,
            }
        },

        methods: {
            fechar() {
                document.getElementById('tynMain').classList.toggle('main-shown')
            },

            seleciona(id, tipo) {
                if (tipo == 5) {
                    this.idProcessoResearch = id;
                    this.load();
                }
            },

            novo() {
                this.idProcessoResearch = 0;
                this.etapa = 0;
                this.idTipoResearch = null;
                this.lstIdNorma = [];
                this.arquivo = null;
                this.files = null;
                this.dsPrompt = null;
                this.resetUpload = !this.resetUpload;
                this.flRequerPromptUsuario = false;

                this.load();
            },

            load() {
                if (this.idProcessoResearch != 0) {
                    this.carregaProcessoResearch();
                }

                this.carregaTipoResearch();
                this.verificaRealizaResearch();
                this.carregaUtilizacoes();
            },

            carregaTipoResearch() {
                let $this = this;
                $this.lstModelos = [];
                axios.get(`${urlApi}/ProcessoResearch/GetTipoResearch`, { showLoading: false, params: {} })
                    .then(res => {
                        if (res.data.success) {
                            $this.lstTipoResearch = res.data.data.rows;

                            if ($this.$route.query.idTipoResearch != undefined) {
                                $this.idTipoResearch = $this.$route.query.idTipoResearch;
                                $this.etapa = $this.etapa + 1;
                            }
                            setTimeout(function () {
                                $this.$nextTick(() => {
                                    $this.montaPopover();
                                });
                            }, 300);

                        }
                    })
                    .catch(res => {
                        if (res.data != undefined) {
                            avisoErro(res.response.data);
                        } else {
                            avisoErro(res.response.statusText);
                        }
                        $this.loading.hide();
                    });
            },

            InitSignalR() {
                try {
                    let $this = this;

                    $this.hubConection.on("RecebeNotificacaoProcessoResearch", function (idProcessoResearch, status, dtAtualizacao) {
                        if ($this.idProcessoResearch == idProcessoResearch) {
                            $this.load();
                        } else {
                            avisoToast('Status do analisador atualizado para ' + status + ' - ' + moment(dtAtualizacao).format('DD/MM/YYYY [às] HH:mm'));
                        }
                    });

                    $this.hubConection.on("AtualizaRealizarProcessoResearch", function (flRealizaProcessoResearch) {
                        $this.flRealizaProcessoResearch = flRealizaProcessoResearch == "Sim" || flRealizaProcessoResearch == "true" ? true : false;
                    });

                    $this.hubConection.on("AtualizaStatusProcessoResearch", function (idProcessoResearch, status,) {
                        if ($this.idProcessoResearch == idProcessoResearch) {
                            $this.mensagemProcessando = status;
                        }
                    });

                }
                catch (ex) {
                    console.log(ex);
                }
            },

            proximo(p_etapa) {
                switch (p_etapa) {
                    case 0:
                        if (this.idTipoResearch) {
                            this.tipoResearch = this.lstTipoResearch.find(x => x.tipoResearch.idTipoResearch == this.idTipoResearch);
                            this.etapa = this.etapa + 1;

                            if (this.tipoResearch.tipoResearch.flRequerPromptUsuario) {
                                this.flRequerPromptUsuario = true;
                            } else {
                                this.flRequerPromptUsuario = false;
                            }

                            this.$nextTick(function () {
                                const el = this.$refs.etapa1;

                                if (el) {
                                    // Use el.scrollIntoView() to instantly scroll to the element
                                    el.scrollIntoView({ behavior: 'smooth' });
                                }
                            });

                        } else {
                            avisoToast("Selecione um tipo de research", "warning");
                        }

                        break;

                    case 1:
                        if (this.files != null && this.files.length > 0) {
                            this.etapa = this.etapa + 1;

                            this.$nextTick(function () {
                                const el = this.$refs.etapa1;

                                if (el) {
                                    // Use el.scrollIntoView() to instantly scroll to the element
                                    el.scrollIntoView({ behavior: 'smooth' });
                                }
                            });
                        } else {
                            avisoToast("Selecione um arquivo", "warning");
                        }

                        break;
                    case 2:
                        if (this.flRequerPromptUsuario && (this.dsPrompt == null || this.dsPrompt.trim() == '')) {
                            avisoToast("Para a função selecionada é necessário fornecer os Detalhes", "warning");
                        } else {
                            var tipoResearch = this.lstTipoResearch.find(x => x.tipoResearch.idTipoResearch == this.idTipoResearch);
                            var usaNormativa = tipoResearch && tipoResearch.tipoResearch.flNorma && this.lstNormas.length > 0;
                            if (this.utilizacoes && this.utilizacoes.permiteRealizarResearch) {
                                if (usaNormativa) {
                                    this.etapa = 3;
                                    this.$nextTick(function () {
                                        const el = this.$refs.etapa3;
                                        if (el) {
                                            el.scrollIntoView({ behavior: 'smooth' });
                                        }
                                    });
                                } else {
                                    this.etapa = 4;
                                    this.enviarProcessoResearch();
                                }
                            }
                            
                        }

                        break;

                    case 3:
                        if (this.utilizacoes && this.utilizacoes.permiteRealizarResearch) 
                        {
                            if (this.flRequerPromptUsuario && (this.dsPrompt == null || this.dsPrompt.trim() == '')) {
                                avisoToast("Para a função selecionada é necessário fornecer os Detalhes", "warning");
                            } else {
                                this.etapa = 4;
                                this.enviarProcessoResearch();
                            }
                        }
                        
                        break;
                    default:
                        break;
                }
            },

            enviarProcessoResearch() {
                let $this = this;
                $this.statusProcessoResearch = 'Processando';
                $this.disabled = true;

                const formData = new FormData();

                //const inputFile = document.querySelector("#myfile");
                //if (inputFile != null) {
                //    for (let i = 0; i < inputFile.files.length; i++) {
                //        formData.append("files", inputFile.files[i]);
                //    }
                //}
                for (let i = 0; i < this.files.length; i++) {
                    formData.append("form.files", this.files[i].key);
                }

                formData.append("form.idTipoResearch", $this.idTipoResearch);
                if ($this.dsPrompt != null && $this.dsPrompt != "") {
                    formData.append("form.dsPrompt", $this.dsPrompt);
                }

                if ($this.lstIdNorma != null && $this.lstIdNorma.length > 0) {
                    $this.lstIdNorma.forEach(function (idNorma) {
                        formData.append("form.idNormas", idNorma);
                    });
                }

                axios.post(`${urlApi}/ProcessoResearch/Post`, formData)
                    .then(res => {
                        if (res.data.success) {
                            avisoToast("Analisador registrado com sucesso, acompanhe a situação no campo status da listagem.");

                            $this.reload = !$this.reload;
                            $this.idProcessoResearch = parseInt(res.data.data);
                            $this.load();
                        } else {
                            $this.flReprocessar = true;
                            avisoErro("Não foi possível enviar o processoResearch.");
                        }
                    })
                    .catch(res => {
                        $this.flReprocessar = true;
                        $this.statusProcessoResearch = 'Cancelada';
                        $this.msgErro = 'Não foi possível enviar o processoResearch.';
                        if (res.response.data) {
                            $this.msgErro = res.response.data.msg + " - " + res.response.data.errors[0];
                            avisoErro(res.response.data.msg + " - " + res.response.data.errors[0]);
                        } else {
                            avisoErro("Não foi possível enviar o processoResearch.");
                        }
                    });
            },

            carregaUtilizacoes() {
                let $this = this;
                axios.get(`${urlApi}/ProcessoResearch/Utilizacoes`, { showLoading: false })
                    .then(res => {
                        $this.flVerificouUtilizacoes = true;
                        if (res.data.success) {
                            $this.utilizacoes = res.data.data;
                        } else {
                            avisoErro("Não foi possível carregar a quantidade de reseachs.");
                        }
                    })
                    .catch(res => {
                        if (res.data != undefined) {
                            avisoErro(res.data);
                        } else {
                            avisoErro("Não foi possível carregar a quantidade de reseachs.");
                        }
                        $this.loading.hide();
                    });
            },

            verificaRealizaResearch() {
                let $this = this;
                axios.get(`${urlApi}/ProcessoResearch/VerificaRealizarProcessoResearch`, { showLoading: false, params: {} })
                    .then(res => {
                        if (res.data.success) {
                            $this.flRealizaProcessoResearch = res.data.data;
                            $this.flVerificouRealizar = true;
                        }
                    })
                    .catch(res => {
                        if (res.data != undefined) {
                            avisoErro(res.response.data);
                        } else {
                            avisoErro(res.response.statusText);
                        }
                    });
            },

            carregaProcessoResearch() {
                let $this = this;
                axios.get(`${urlApi}/ProcessoResearch/Get/${$this.idProcessoResearch}`)
                    .then(res => {
                        $this.processoResearch = null;
                        if (res.data.success) {
                            var result = res.data.data;

                            var status = '';
                            if (result.lstProcessoResearchMovimento.length > 0) {
                                status = result.lstProcessoResearchMovimento[result.lstProcessoResearchMovimento.length - 1].dsMovimento;
                                $this.statusProcessoResearch = status;
                                if (status == 'Cancelada') {
                                    $this.msgErro = result.lstProcessoResearchMovimento[result.lstProcessoResearchMovimento.length - 1].dsResultApi;
                                }
                            }

                            var lstFonteDados, resposta = null;
                            if (result.lstProcessoResearchDocumento.length > 0) {
                                lstFonteDados = result.lstProcessoResearchDocumento.filter(x => x.flResposta == false);
                                resposta = (result.lstProcessoResearchDocumento.filter(x => x.flResposta == true) ? result.lstProcessoResearchDocumento.filter(x => x.flResposta == true)[0] : null);

                            }

                            $this.processoResearch = {
                                idProcessoResearch: result.processoResearch.idProcessoResearch,
                                dsLogin: result.processoResearch.dsLogin,
                                dsNome: result.processoResearch.dsNome,
                                dtInclusao: moment(result.processoResearch.dtInclusao).format('DD/MM/YYYY [às] HH:mm'),
                                nmTipoResearch: result.tipoResearch.dsNome,
                                status: status,
                                usuario: result.usuario,
                                tipoResearch: result.tipoResearch,
                                lstFonteDados: lstFonteDados,
                                resposta: resposta,
                                dsPrompt: result.processoResearch.dsPrompt,
                            };

                            if (result.lstNormas && result.lstNormas.length > 0) {
                                $this.lstNormasSelecionadas = result.lstNormas;
                            } else {
                                $this.lstNormasSelecionadas = [];
                            }
                        } else {
                            avisoErro("Não foi possível carregar o artefato.");
                        }

                    })
                    .catch(res => {
                        if (res.data != undefined) {
                            avisoErro(res.data);
                        } else {
                            avisoErro("erro");
                        }
                        //$this.loading.hide();
                    });
            },

            downloadDocumento(item) {
                axios({
                    url: `${urlApi}/ProcessoResearch/DownloadDocumento/${item.idProcessoResearchDocumento}`,
                    method: 'GET',
                    responseType: 'blob',
                }).then((response) => {
                    const nmArquivo = this.getNomeArquivo(item.urlArquivo || item.fileId);
                    const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' }));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', nmArquivo);
                    document.body.appendChild(link);
                    link.click();
                });
            },

            download(urlArquivo, flNome = false) {
                var nmArquivo = "";
                var nomeArquivo = urlArquivo.split('/');
                if (nomeArquivo.length > 0) {
                    if (flNome) {
                        nmArquivo = nomeArquivo[nomeArquivo.length - 1];
                    } else {
                        nmArquivo = nomeArquivo[nomeArquivo.length - 1].slice(7);
                    }
                }

                axios({
                    url: `${urlApi}/Utilidade/BaixarArquivo?urlArquivo=${urlArquivo}&nmArquivo=${nmArquivo}`, //your url
                    method: 'GET',
                    responseType: 'blob', // important
                }).then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', nmArquivo); //or any other extension
                    document.body.appendChild(link);
                    link.click();
                });
            },

            downloadProcessoResearch(urlArquivo, dsNome) {
                var nmArquivo = "";
                var nomeArquivo = urlArquivo.split('/');
                if (nomeArquivo.length > 0) {
                    nmArquivo = nomeArquivo[nomeArquivo.length - 1];
                    nmArquivo = dsNome + "." + nmArquivo.split(".")[1];
                }

                axios({
                    url: `${urlApi}/ProcessoResearch/DownloadDocumento/${this.processoResearch.resposta.idProcessoResearchDocumento}`,
                    method: 'GET',
                    responseType: 'blob',
                }).then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' }));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', nmArquivo); //or any other extension
                    document.body.appendChild(link);
                    link.click();
                });
            },

            getNomeArquivo(urlArquivo) {
                if (!urlArquivo) {
                    return "dados";
                }
                var nomeArquivo = urlArquivo.split('/');
                if (nomeArquivo.length > 0) {
                    return nomeArquivo[nomeArquivo.length - 1].slice(7);
                }
                return "dados";
            },

            openReferencia(cdConteudo, idItemPesquisa, dsReferencia) {
                this.modalDetalhes = {
                    cdConteudo: cdConteudo,
                    idItemPesquisa: idItemPesquisa,
                    dsReferencia: dsReferencia,
                };
                this.showModalDetalhes = !this.showModalDetalhes;
            },

            getDataBs(item) {
                return ` <span class="mb-0"> ${(item.dsTipoResearch != null ? item.dsTipoResearch : item.dsTipoResearch)}</span>`;
            },

            montaPopover() {
                var popovers = document.querySelectorAll(".popover");
                // Itera sobre cada elemento e remove-o
                popovers.forEach(function (popover) {
                    popover.remove();
                });
                this.$nextTick(function () {
                    var popoverTriggerList = document.querySelectorAll(
                        '[data-bs-toggle="popoverModelo"]',
                    );// eslint-disable-line no-console

                    if (popoverTriggerList.length > 0) {
                        [].slice
                            .call(popoverTriggerList)
                            .map(function (popoverTriggerEl) {
                                return new window.bootstrap.Popover(popoverTriggerEl, {
                                    trigger: "hover",
                                    boundary: "window",
                                    html: true,
                                    placement: "top",
                                    customClass: "custom-popover"
                                });
                            });
                    }
                });
            },

            downloadNormativa(urlArquivo, dsNome) {
                var nmArquivo = "";
                var nomeArquivo = urlArquivo.split('/');
                if (nomeArquivo.length > 0) {
                    nmArquivo = nomeArquivo[nomeArquivo.length - 1];
                    nmArquivo = dsNome + "." + nmArquivo.split(".")[1];
                }

                axios({
                    url: `${urlApi}/Utilidade/BaixarArquivo?urlArquivo=${urlArquivo}&nmArquivo=${nmArquivo}`, //your url
                    method: 'GET',
                    responseType: 'blob', // important
                }).then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', nmArquivo); //or any other extension
                    document.body.appendChild(link);
                    link.click();
                });
            },

            setUploadFile(lstFiles) {
                if (lstFiles == null || lstFiles === '') {
                    return;
                }
                if (this.files == null) {
                    this.files = [];
                }
                const items = Array.isArray(lstFiles) ? lstFiles : [lstFiles];
                for (let i = 0; i < items.length; i++) {
                    if (!this.files.some(f => f.key === items[i].key)) {
                        this.files.push(items[i]);
                    }
                }
            },

            deleteUploadFile(hash) {
                this.files = this.files.filter(function (obj) { return obj.hash !== hash });
            },
        },
        mounted: function () {
            this.load();


            if (this.hubConection != undefined) {
                // signalR
                this.InitSignalR();
            }
        },
        watch: {
            idTipoResearch: function () {
                this.lstIdNorma = [];
                if (this.idTipoResearch > 0) {
                    this.tipoResearch = this.lstTipoResearch.find(x => x.tipoResearch.idTipoResearch == this.idTipoResearch);
                    if (this.tipoResearch.tipoResearch.flRequerPromptUsuario) {
                        this.flRequerPromptUsuario = true;
                    } else {
                        this.flRequerPromptUsuario = false;
                    }
                    if (this.etapa > 2) {
                        this.etapa = 2;
                    }
                } else {
                    this.etapa = 0;
                }
                
            }
        }
    };
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
    .tyn-qa-bubbly .tyn-qa-item:nth-child(even) .tyn-qa-message.bg-question, .tyn-qa-bubbly .tyn-qa-item:nth-child(odd) .tyn-qa-message.bg-question {
        background: var(--qa-bg-human);
    }

    .tyn-qa-bubbly .tyn-qa-item:nth-child(odd) .tyn-qa-message.bg-response, .tyn-qa-bubbly .tyn-qa-item:nth-child(even) .tyn-qa-message.bg-response {
        background: var(--qa-bg);
    }

    a {
        color: var(--bs-body-color);
    }

        a:hover, li:hover {
            text-decoration: underline;
            color: var(--bs-body-color);
        }

    .referencias {
        padding-left: 30px;
    }

        .referencias li {
            font-size: 14px;
        }

    .resposta {
        text-align: justify;
    }

    /* ========================================
       ESTILOS MODERNOS - RESEARCH
       ======================================== */
    
    @keyframes fadeInUp {
        from {
            opacity: 0;
            transform: translateY(20px);
        }
        to {
            opacity: 1;
            transform: translateY(0);
        }
    }

    @keyframes pulse {
        0%, 100% {
            transform: scale(1);
        }
        50% {
            transform: scale(1.02);
        }
    }

    @keyframes shimmer {
        0% {
            background-position: -1000px 0;
        }
        100% {
            background-position: 1000px 0;
        }
    }

    /* Melhorias nas respostas da IA */
    .tyn-qa-message {
        transition: all 0.3s ease;
        
        &.bg-question {
            background: linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%) !important;
            border-left: 4px solid #1f7bff;
            box-shadow: 0 2px 8px rgba(31, 123, 255, 0.15);
        }

        &.bg-response {
            background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%) !important;
            border-left: 4px solid #00d084;
            box-shadow: 0 2px 8px rgba(0, 208, 132, 0.15);
        }
    }

    /* Botões de opções modernos */
    .btn-outline-primary {
        border: 2px solid #1f7bff;
        color: #1f7bff;
        background: transparent;
        border-radius: 12px;
        padding: 0.65rem 1.5rem;
        font-weight: 600;
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        box-shadow: 0 2px 8px rgba(31, 123, 255, 0.1);
        display: inline-flex;
        align-items: center;
        gap: 0.5rem;

        &:hover {
            background: linear-gradient(135deg, #1f7bff 0%, #00d084 100%);
            border-color: transparent;
            color: white;
            box-shadow: 0 6px 20px rgba(31, 123, 255, 0.3);
            transform: translateY(-2px);

            svg {
                transform: rotate(90deg) scale(1.1);
            }
        }

        &:active {
            transform: translateY(0);
        }

        svg {
            transition: transform 0.3s ease;
        }
    }

    /* Progress bar moderna */
    .progress {
        height: 8px;
        border-radius: 10px;
        background: rgba(233, 236, 239, 0.5);
        overflow: hidden;
        box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.1);
    }

    .progress-bar {
        border-radius: 10px;
        background: linear-gradient(90deg, #1f7bff 0%, #00d084 100%);
        background-size: 200% 100%;
        animation: shimmer 2s linear infinite;
        box-shadow: 0 2px 8px rgba(31, 123, 255, 0.4);
    }

    /* Animações para mensagens de erro */
    .text-danger {
        animation: pulse 2s ease-in-out infinite;
    }

    /* Melhorias nos radio buttons */
    input[type="radio"] {
        appearance: none;
        -webkit-appearance: none;
        -moz-appearance: none;
        width: 1.25rem;
        height: 1.25rem;
        border: 2px solid #cbd5e0;
        border-radius: 50%;
        outline: none;
        transition: all 0.3s ease;
        cursor: pointer;
        position: relative;
        background: white;
        flex-shrink: 0;

        &::before {
            content: '';
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%) scale(0);
            width: 10px;
            height: 10px;
            border-radius: 50%;
            background: white;
            transition: transform 0.2s ease;
        }

        &:checked {
            background: linear-gradient(135deg, #1f7bff 0%, #00d084 100%);
            border-color: #1f7bff;
            box-shadow: 0 0 0 4px rgba(31, 123, 255, 0.15);

            &::before {
                transform: translate(-50%, -50%) scale(1);
            }
        }

        &:hover:not(:disabled) {
            border-color: #1f7bff;
            transform: scale(1.1);
        }

        &:focus {
            outline: none;
            box-shadow: 0 0 0 4px rgba(31, 123, 255, 0.15);
        }

        &:disabled {
            opacity: 0.5;
            cursor: not-allowed;
            background: #f1f3f5;
        }
    }

    label {
        cursor: pointer;
        transition: color 0.3s ease;
        user-select: none;

        &:hover {
            color: #1f7bff;
        }
    }

    /* Textarea moderna */
    :deep(.form-control) {
        border: 2px solid #e9ecef;
        border-radius: 14px;
        padding: 1rem 1.25rem;
        font-size: 1rem;
        line-height: 1.6;
        color: #2d3748;
        background-color: #ffffff;
        resize: vertical;
        min-height: 120px;
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        font-family: inherit;

        &::placeholder {
            color: #a0aec0;
            opacity: 1;
        }

        &:hover:not(:focus) {
            border-color: #cbd5e0;
            background-color: #f8f9fa;
        }

        &:focus {
            outline: none;
            border-color: #1f7bff;
            background-color: #ffffff;
            box-shadow: 0 0 0 4px rgba(31, 123, 255, 0.1),
                        0 4px 12px rgba(31, 123, 255, 0.15);
            transform: translateY(-1px);
        }

        &:disabled {
            background-color: #f1f3f5;
            cursor: not-allowed;
            opacity: 0.6;
        }
    }

    /* Links melhorados */
    .c-pointer {
        color: #1f7bff;
        text-decoration: none;
        transition: all 0.3s ease;
        font-weight: 500;

        &:hover {
            color: #00d084;
            text-decoration: underline;
        }
    }

    .item-fonte {
        display: inline-block;
        margin-right: 0.5rem;
        padding: 0.25rem 0.75rem;
        background: rgba(31, 123, 255, 0.1);
        border-radius: 8px;
        transition: all 0.3s ease;

        &:hover {
            background: rgba(31, 123, 255, 0.2);
            transform: translateY(-1px);
        }
    }

    /* Popover customizado */
    :deep(.custom-popover) {
        border-radius: 12px;
        box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
        border: 2px solid rgba(31, 123, 255, 0.2);

        .popover-header {
            background: linear-gradient(135deg, #1f7bff 0%, #00d084 100%);
            color: white;
            border-radius: 10px 10px 0 0;
            font-weight: 600;
        }

        .popover-body {
            font-size: 0.9rem;
            line-height: 1.6;
        }
    }

    /* Área de upload melhorada */
    :deep(.input-group) {
        border-radius: 12px;
        overflow: hidden;
        transition: all 0.3s ease;

        &:hover {
            box-shadow: 0 4px 12px rgba(31, 123, 255, 0.15);
        }
    }

    :deep(.btn-primary) {
        background: linear-gradient(135deg, #1f7bff 0%, #0056d2 100%);
        border: none;
        border-radius: 10px;
        padding: 0.65rem 1.5rem;
        font-weight: 600;
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        box-shadow: 0 4px 12px rgba(31, 123, 255, 0.3);

        &:hover {
            background: linear-gradient(135deg, #0056d2 0%, #003d99 100%);
            transform: translateY(-2px);
            box-shadow: 0 6px 20px rgba(31, 123, 255, 0.4);
        }

        &:active {
            transform: translateY(0);
        }
    }

    /* Ícones SVG */
    svg {
        transition: all 0.3s ease;
    }

    .bi-plus-lg {
        font-weight: bold;
    }

    /* Container de mensagens */
    .tyn-chat-body {
        animation: fadeInUp 0.5s ease-out;
    }

    /* Melhorias no container */
    .container {
        transition: all 0.3s ease;
    }

    /* Destaque de texto em negrito */
    #negrito {
        font-weight: 700;
        color: #2d3748;
        background: linear-gradient(135deg, rgba(31, 123, 255, 0.1) 0%, rgba(0, 208, 132, 0.1) 100%);
        padding: 0.15rem 0.5rem;
        border-radius: 6px;
    }

    /* Melhorias no form-group */
    .form-group {
        position: relative;
        margin-top: 1rem;
    }

    /* Responsivo */
    @media (max-width: 768px) {
        .btn-outline-primary {
            width: 100%;
            justify-content: center;
            padding: 0.75rem 1.5rem;
        }

        input[type="radio"] {
            width: 1.1rem;
            height: 1.1rem;
        }

        :deep(.form-control) {
            padding: 0.875rem 1rem;
            font-size: 0.95rem;
            border-radius: 12px;
            min-height: 100px;
        }

        .item-fonte {
            font-size: 0.85rem;
            padding: 0.2rem 0.5rem;
        }
    }

    @media (max-width: 576px) {
        .btn-outline-primary {
            font-size: 0.9rem;
            padding: 0.7rem 1.25rem;
        }

        .tyn-qa-message {
            padding: 1rem;
        }

        :deep(.form-control) {
            padding: 0.75rem 0.875rem;
            font-size: 0.9rem;
            min-height: 90px;
        }

        #negrito {
            padding: 0.1rem 0.4rem;
            font-size: 0.9rem;
        }
    }

    /* ============================================
       DARK THEME - Research
       ============================================ */

    [data-bs-theme="dark"] .tyn-qa-message.bg-question {
        background: linear-gradient(135deg, #1e3a8a 0%, #1e40af 100%) !important;
        border-left-color: #60a5fa;
        box-shadow: 0 2px 8px rgba(59, 130, 246, 0.2);
        color: #e0f2fe;
    }

    [data-bs-theme="dark"] .tyn-qa-message.bg-response {
        background: linear-gradient(135deg, #064e3b 0%, #065f46 100%) !important;
        border-left-color: #34d399;
        box-shadow: 0 2px 8px rgba(16, 185, 129, 0.2);
        color: #d1fae5;
    }

    [data-bs-theme="dark"] .btn-outline-primary {
        border-color: #3b82f6;
        color: #60a5fa;
        background: transparent;

        &:hover {
            background: linear-gradient(135deg, #3b82f6 0%, #10b981 100%);
            color: white;
            box-shadow: 0 6px 20px rgba(59, 130, 246, 0.4);
        }
    }

    [data-bs-theme="dark"] .progress {
        background: #0f1117;
    }

    [data-bs-theme="dark"] .progress-bar {
        background: linear-gradient(90deg, #3b82f6 0%, #10b981 100%);
    }

    [data-bs-theme="dark"] input[type="radio"] {
        background: #0f1117;
        border-color: rgba(255, 255, 255, 0.2);

        &:checked {
            background: linear-gradient(135deg, #3b82f6 0%, #10b981 100%);
            border-color: #3b82f6;
        }

        &:disabled {
            background: #1a1d29;
        }
    }

    [data-bs-theme="dark"] label {
        color: #e5e7eb;

        &:hover {
            color: #60a5fa;
        }
    }

    [data-bs-theme="dark"] :deep(.form-control) {
        background: #0f1117;
        border-color: rgba(255, 255, 255, 0.12);
        color: #f3f4f6;

        &::placeholder {
            color: #6b7280;
        }

        &:hover:not(:focus) {
            border-color: rgba(255, 255, 255, 0.2);
            background: #1a1d29;
        }

        &:focus {
            background: #1a1d29;
            border-color: #60a5fa;
            color: #ffffff;
            box-shadow: 0 0 0 4px rgba(96, 165, 250, 0.15),
                        0 4px 12px rgba(96, 165, 250, 0.2);
        }

        &:disabled {
            background: #1a1d29;
            color: #6b7280;
        }
    }

    [data-bs-theme="dark"] .c-pointer {
        color: #60a5fa;

        &:hover {
            color: #34d399;
        }
    }

    [data-bs-theme="dark"] .item-fonte {
        background: rgba(59, 130, 246, 0.15);
        color: #93c5fd;

        &:hover {
            background: rgba(59, 130, 246, 0.25);
        }
    }

    [data-bs-theme="dark"] :deep(.custom-popover) {
        background: #1e2330;
        border-color: rgba(96, 165, 250, 0.3);
        box-shadow: 0 8px 24px rgba(0, 0, 0, 0.5);

        .popover-header {
            background: linear-gradient(135deg, #3b82f6 0%, #10b981 100%);
        }

        .popover-body {
            background: #1e2330;
            color: #e5e7eb;
        }
    }

    [data-bs-theme="dark"] :deep(.btn-primary) {
        background: linear-gradient(135deg, #2563eb 0%, #1e40af 100%);

        &:hover {
            background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);
        }
    }

    [data-bs-theme="dark"] #negrito {
        color: #f9fafb;
        background: linear-gradient(135deg, rgba(59, 130, 246, 0.15) 0%, rgba(16, 185, 129, 0.15) 100%);
    }

    [data-bs-theme="dark"] .tyn-qa-message p,
    [data-bs-theme="dark"] .tyn-qa-message strong {
        color: inherit;
    }

    [data-bs-theme="dark"] :deep(.input-group) {
        &:hover {
            box-shadow: 0 4px 12px rgba(96, 165, 250, 0.2);
        }
    }

    [data-bs-theme="dark"] h5 {
        color: #f9fafb;
    }

    [data-bs-theme="dark"] .referencias strong {
        color: #f9fafb;
    }
</style>
